import 'app/index.css'

import React from 'react'
import ReactDOM from 'react-dom'
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import { Router, Route } from 'react-router-dom'
import createBrowserHistory from 'history/createBrowserHistory'
import Axios from 'axios'

import reducers from 'app/reducers/index'
import { loadOpenings, setIsFetching } from 'reducers/positions'
import track from './tracking.js'

import App from 'app/index'

const history = createBrowserHistory()

let store = null

const initialState = window.__INITIAL_STATE__
store = createStore(reducers, initialState)

// try to fetch /jobs again when jobs is empty
if (store.getState().positions.locations == null) {
  store.dispatch(setIsFetching(true))
  setTimeout(() => {
    Axios.get('/jobs')
      .then(response => {
        store.dispatch(loadOpenings(response.data))
      })
      .catch(error => {
        console.log(error)
      })
  }, 5000)
}

delete window.__INITIAL_STATE__

store.subscribe(() => {
  document.title = store.getState().global.title
})

history.listen(track)
track(history.location)

ReactDOM.hydrate(
  <div className='flex flex-column sans-serif relative black min-vh-100'>
    <Provider store={store}>
      <Router history={history}>
        <Route component={App} />
      </Router>
    </Provider>
  </div>
  , document.querySelector('#app')
)
